import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreferencesFormComponent } from './preferences-form/preferences-form.component';
import { CardModule, InputModule, LocalLoaderModule, SosAccountStoreModule, SosAuthorizationStoreModule } from '@serviceos-ng/core';
import { CommunicationPreferencesCardComponent } from './communication-preferences-card/communication-preferences-card.component';



@NgModule({
  declarations: [
    PreferencesFormComponent,
    CommunicationPreferencesCardComponent
  ],
  imports: [
    CommonModule,
    InputModule,
    LocalLoaderModule,
    CardModule,
    SosAccountStoreModule,
    SosAuthorizationStoreModule,
  ],
  exports: [
    PreferencesFormComponent,
    CommunicationPreferencesCardComponent
  ]
})
export class PreferencesModule { }
